import { render, staticRenderFns } from "./loss.vue?vue&type=template&id=085a22ed&"
import script from "./loss.vue?vue&type=script&lang=js&"
export * from "./loss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports